import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const invalidatePermissions = () => window.dispatchEvent(new Event("permissions-updated"));

export function usePermissions() {
  const { user } = useAuth();
  const location = useLocation();
  const athleteId = location.pathname.match(/^\/athlete\/([^/]+)/)?.[1] || (location.pathname === "/athlete" ? new URLSearchParams(location.search).get("id") : "");
  const [perms, setPerms] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => {
      if (!user?.role) return;
      api.get(`/me/permissions${athleteId ? `?athlete_id=${encodeURIComponent(athleteId)}` : ""}`).then(r => { if (alive) setPerms(r.data); }).catch(() => alive && setPerms({ sections: {}, levels: {} }));
    };
    setPerms(null); load();
    window.addEventListener("focus", load);
    window.addEventListener("permissions-updated", load);
    return () => { alive = false; window.removeEventListener("focus", load); window.removeEventListener("permissions-updated", load); };
  }, [user?.user_id, user?.role, athleteId]);
  return { perms, can: section => !!perms?.sections?.[section], canEdit: section => perms?.levels?.[section] === "edit", loaded: !!perms };
}
